import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const PurchaseDealerProfitInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Profit Information">
            <DataRow
                label="Vehicle Profit"
                value={pdfData.vehicle_profit.toDollarFormat()}
                variant="muted"
                isLast
            />
        </Panel>
    )
}
